function addControls() {
  for (const root of document.querySelectorAll('.kg-video-container')) {
    for (const video of root.querySelectorAll('video')) {
      video.controls = true;
      video.preload = 'auto';
    }
  }
}

addControls();
